<template>
  <div class="manage-address-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <div class="row">
                <div class="col">
                  <h1>{{ passedCasesProps.ClaimantFullName }}'s Address</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body div-responsive">
            <form>
              <div class="form-group">
                <div class="box-body">
                  <div class="box-row">
                    <div class="box-col box-col-left">Address 1</div>
                    <div class="box-col box-col-right">
                      <input id="address-line1" name="address-line1" autocomplete="address-line1" type="text" v-model="claimant.addressLine1" placeholder="Address 1"
                             :class="hasError && addressLine1Error ? 'is-invalid' : ''" @blur="trimField('addressLine1')" />
                      <div v-if="hasError && addressLine1Error" class="text-danger">{{ addressLine1Error }}</div>
                    </div>
                  </div>
                  <div class="box-row">
                    <div class="box-col box-col-left">Address 2</div>
                    <div class="box-col box-col-right">
                      <input id="address-line2" name="address-line2" autocomplete="address-line2" type="text" v-model="claimant.addressLine2" placeholder="Address 2"
                             :class="hasError && addressLine2Error ? 'is-invalid' : ''" @blur="trimField('addressLine2')" />
                      <div v-if="hasError && addressLine2Error" class="text-danger">{{ addressLine2Error }}</div>
                    </div>
                  </div>
                  <div class="box-row">
                    <div class="box-col box-col-left">City</div>
                    <div class="box-col box-col-right">
                      <!-- <vue-suggestion
                        :items="filteredCities"
                        :ref="'citySuggestion'"
                        inputClasses="city-suggestion"
                        placeholder="Enter a location"
                        :itemTemplate="citySuggestion"
                        @changed="changeCity($event)"
                        @selected="selectCity($event)"
                        :setLabel="setLabel"
                      >
                      </vue-suggestion> -->
                      <input id="address-level2" autocomplete="address-level2" name="address-level2" type="text" v-model="claimant.city" placeholder="City"
                             :class="hasError && cityError ? 'is-invalid' : ''" @blur="trimField('city')" />
                      <div v-if="hasError && cityError" class="text-danger">{{ cityError }}</div>
                    </div>
                  </div>
                  <div class="box-row">
                    <div class="box-col box-col-left">State</div>
                    <div class="box-col box-col-right select-state">
                      <div v-if="!clickState" @click="handleState">
                        <input id="address-level1" autocomplete="address-level1" name="address-level1" type="text" readonly v-model="claimant.state" placeholder="Click to choose the State"
                               :class="hasError && stateError ? 'is-invalid' : ''" />
                      </div>
                      <select v-else class="textbox" :class="hasError && stateError ? 'is-invalid' : ''" v-model="claimant.state">
                        <option hidden value="">Please choose ...</option>
                        <option v-for="(state, index) in states" :value="state.value" :key="index">{{ state.text }}</option>
                      </select>
                      <div v-if="hasError && stateError" class="text-danger">{{ stateError }}</div>
                    </div>
                  </div>
                  <div class="box-row">
                    <div class="box-col box-col-left">Postcode</div>
                    <div class="box-col box-col-right">
                      <input id="postal-code" name="postal-code" autocomplete="postal-code" type="text" maxlength="4" v-model="claimant.postcode" placeholder="Postcode"
                             :class="hasError && postcodeError ? 'is-invalid' : ''" @blur="trimField('postcode')" />
                      <div v-if="hasError && postcodeError" class="text-danger">{{ postcodeError }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" dark @click.stop="handleModal($event)">Cancel</v-btn>
                    <button style="min-width: 120px;
    min-height: 39px;
    border-radius: 5px;
    text-transform: capitalize;
    background-color: #525252; color: white" dark @click.prevent="save">Save</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import CitySuggestion from '@/components/CitySuggestion'

  export default {
    name: 'AdminManageClaimantAddressModal',
    props: ['passedCasesProps'],
    components: {
      CitySuggestion,
    },
    data() {
      return {
        loadModal: false,
        clickState: false,
        clickLocation: false,
        claimant: utilities.initClaimant(),
        hasError: false,

        cities: [],
        listCities: [],
        filteredCities: [],
        citySuggestion: CitySuggestion,
        states: utilities.getStates(),

        loaded: false,
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      addressLine1Error() {
        const s = String(this.claimant.addressLine1 === undefined || this.claimant.addressLine1 === null ? '' : this.claimant.addressLine1).trim()
        if (!s) return ''
        if (s.length > 100) return 'Address line 1 must not exceed 100 characters.'
        const e = utilities.getValidateAddressError(s)
        return e === null ? '' : e
      },
      addressLine2Error() {
        const s = String(this.claimant.addressLine2 === undefined || this.claimant.addressLine2 === null ? '' : this.claimant.addressLine2).trim()
        if (!s) return ''
        if (s.length > 100) return 'Address line 2 must not exceed 100 characters.'
        const e = utilities.getValidateAddressError(s)
        return e === null ? '' : e
      },
      cityError() {
        const s = String(this.claimant.city === undefined || this.claimant.city === null ? '' : this.claimant.city).trim()
        if (!s) return ''
        const e = utilities.getValidateCityError(s)
        if (e !== null) return e
        if (s.length > 20) return 'City must not exceed 20 characters.'
        return ''
      },
      stateError() {
        const s = this.claimant.state
        if (s === undefined || s === null || String(s).trim() === '') return ''
        return ''
      },
      postcodeError() {
        const raw = this.claimant.postcode
        const s = raw === undefined || raw === null ? '' : String(raw).trim()
        if (!s) return ''
        const e = utilities.getValidatePostCodeError(s)
        return e === null ? '' : e
      },
    },
    methods: {
      trimField(prop) {
        const v = this.claimant[prop]
        if (v === undefined || v === null) return
        this.claimant[prop] = String(v).trim()
      },
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },
      handleState() {
        this.clickState = true
      },

      async loadData() {
        this.listCities = await utilities.getCities()
        this.filteredCities = this.listCities
      },
      save() {
        this.trimField('addressLine1')
        this.trimField('addressLine2')
        this.trimField('city')
        this.trimField('postcode')
        this.hasError = false
        if (this.addressLine1Error || this.addressLine2Error || this.cityError || this.stateError || this.postcodeError) {
          this.hasError = true
          return
        }

        if (this.$parent.singleCase != undefined && this.$parent.singleCase.id != '') {

          this.$parent.singleCase.ClaimantAddressLine1 = this.claimant.addressLine1
          this.$parent.singleCase.ClaimantAddressLine2 = this.claimant.addressLine2
          this.$parent.singleCase.ClaimantCity = this.claimant.city
          this.$parent.singleCase.ClaimantState = this.claimant.state
          this.$parent.singleCase.ClaimantPostcode = this.claimant.postcode
          this.$parent.singleCase.ClaimantCountry = this.claimant.country
          this.$parent.contactKey += 1
          this.handleModal()
        } else {
          this.$parent.singleCase.ClaimantAddressLine1 = this.claimant.addressLine1
          this.$parent.singleCase.ClaimantAddressLine2 = this.claimant.addressLine2
          this.$parent.singleCase.ClaimantCity = this.claimant.city
          this.$parent.singleCase.ClaimantState = this.claimant.state
          this.$parent.singleCase.ClaimantPostcode = this.claimant.postcode
          this.$parent.singleCase.ClaimantCountry = 'Australia'
          this.$parent.contactKey += 1
          this.handleModal()
        }
        // If cancel, don't save
      },
      changeCity($event) {
        this.filteredCities = this.listCities.filter((x) => x.name.toLowerCase().indexOf($event.toLowerCase()) !== -1)
      },
      setLabel(item) {
        return item.name
      },
      selectCity(index, $event) {},
    },
    async beforeMount() {
      await this.loadData()
    },
    mounted() {
      setTimeout(() => {
        $('.vue-suggestion input.city-suggestion').each((index, element) => {
          $(element).focusout(() => {
            this.$refs['citySuggestion' + index][0].searchText = ''
          })
        })
      }, 500)
    },
    updated() {
      if (!this.loaded) {
        this.claimant = {
          addressLine1: this.passedCasesProps.ClaimantAddressLine1,
          addressLine2: this.passedCasesProps.ClaimantAddressLine2,
          city: this.passedCasesProps.ClaimantCity,
          state: this.passedCasesProps.ClaimantState,
          postcode: this.passedCasesProps.ClaimantPostcode,
          country: this.passedCasesProps.ClaimantCountry,
        }
        this.loaded = true
      }
    },
  }
</script>
